// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.

const mediaQueries = {
  wideScreens: '1920px',
  desktop: '1440px',
  laptop: '1024px',
  tablet: '640px'
} as const;

export default mediaQueries;
